import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params) {
    return store.dispatch('checkResponseApi', await Api().get('goodstransfers', { params }))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('goodstransfer?gt_id=' + data.gt_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('goodstransfer', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('goodstransfer', data, options))
  },

  async done (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('goodstransfer/done', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('goodstransfer', { data: data }, options))
  },

  async getLatestCode (data) {
    let param = '?warehouse_id=' + data.warehouse_id +
								'&short_name=' + data.short_name
    return store.dispatch('checkResponseApi', await Api().get('goodstransfer/latest_code' + param))
  },

}



// WEBPACK FOOTER //
// ./src/api/GoodsTransferService.js